import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { SignupTemplate } from "components/entrance/signup";
import {
  setPhoneNumber,
  fetchConfirmPhoneNumber,
} from "redux/slices/signup/signupSlice";
import { getPhoneNumberFormat } from "utils/format";

const Signup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { phoneNumber } = useSelector((state) => state.signup);

  useEffect(() => {
    window.localStorage.removeItem("signUpBasicInfo");
  }, []);

  const handleChangeNumber = (e) => {
    const numFormat = getPhoneNumberFormat(e.target.value);
    if (numFormat) {
      dispatch(setPhoneNumber(numFormat));
    }
  };

  const handleClickConfirm = async () => {
    let updatePhoneNumber = phoneNumber;
    if (phoneNumber.replace(/-/gi, "").length === 10) {
      const numFull = phoneNumber.replace(/-/gi, "");
      updatePhoneNumber = `${numFull.slice(0, 3)}-${numFull.slice(
        3,
        6,
      )}-${numFull.slice(6, 10)}`;
    }
    dispatch(fetchConfirmPhoneNumber(updatePhoneNumber))
      .unwrap()
      .then((data) => {
        navigate(`confirm`, { state: data });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <SignupTemplate
      title={`관리자 확인을 위해\n휴대폰 번호를 입력해주세요`}
      inputLabel="아이디"
      inputValue={phoneNumber}
      inputValueChange={handleChangeNumber}
      inputIsAutoFocus={true}
      buttonText=""
      onClickFooter={handleClickConfirm}
      onClickBack={() => navigate("/entrance", { replace: true })}
    />
  );
};
export default Signup;
